/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AddGuardianIcon from 'icons/AddGuardianIcon';

const messages = defineMessages({
  title: {id: 'navigation.add'},
});

const AddItem = () => (
  <RouteLinkItem
    iconBefore={AddGuardianIcon}
    route="midas/guardians/add"
    title={messages.title}
  />
);

export default AddItem;
